<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <vx-card>
      <!-- Avatar Row -->
      <!-- <pre>
        {{ permissionsSubMenu }}
      </pre> -->
      <ValidationObserver v-slot="{ handleSubmit }" ref="form">
        <form @submit.prevent="handleSubmit">
          <div class="vx-row">
            <div class="vx-col w-2/5 mt-5">
              <validation-provider :name="$t('sections.system.dataForm.nameTh')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.system.dataForm.nameTh") }}*</label>
                <vs-input type="text" v-model="form.nameTh" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-2/5 mt-5">
              <validation-provider :name="$t('sections.system.dataForm.nameEn')" rules="" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.system.dataForm.nameEn") }}</label>
                <vs-input type="text" v-model="form.nameEn" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-1/5 mt-5">
              <validation-provider :name="$t('sections.system.dataForm.status')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.system.dataForm.status") }}*</label>
                <v-select v-model="form.status" :clearable="false" :options="statusesOptions" name="status" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>

          <!-- Permissions -->
          <div class="vx-row mt-5">
            <div class="vx-col w-full">
              <div class="flex items-end px-3">
                <feather-icon svgClasses="w-6 h-6" icon="LockIcon" class="mr-2" />
                <span class="font-medium text-lg leading-none">{{ $t('sections.system.dataForm.permissions') }}</span>
              </div>
              <vs-divider />
            </div>
          </div>

          <div class="block overflow-x-auto">
            <table class="w-full">
              <tr>
                <th class="font-semibold text-base text-left px-3 py-2" >{{ $t('sections.system.dataForm.menu') }}</th>
                <th class="font-semibold text-base text-left px-3 py-2" >{{ $t('sections.system.dataForm.subMenus') }}</th>
                <th class="font-semibold text-base text-left px-3 py-2" >{{ $t('sections.system.dataForm.visible') }}</th>
                <th class="font-semibold text-base text-left px-3 py-2" >{{ $t('sections.system.dataForm.create') }}</th>
                <th class="font-semibold text-base text-left px-3 py-2" >{{ $t('sections.system.dataForm.edit') }}</th>
                <th class="font-semibold text-base text-left px-3 py-2" >{{ $t('sections.system.dataForm.delete') }}</th>
              </tr>
              <tr v-for="(res, name) in form.permissions" :key="name">
                <td class="px-3 py-2">{{ $t(res.menu.i18n) }}</td>
                <td class="px-3 py-2">{{ $t(res.i18n) }}</td>
                <td class="px-3 py-2"><vs-checkbox v-model="res.visible" /></td>
                <td class="px-3 py-2"><vs-checkbox v-model="res.create" /></td>
                <td class="px-3 py-2"><vs-checkbox v-model="res.edit" /></td>
                <td class="px-3 py-2"><vs-checkbox v-model="res.delete" /></td>
              </tr>
            </table>
          </div>

          <!-- Save & Reset Button -->
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="mt-8 flex flex-wrap items-center justify-end">
                <vs-button class="ml-auto mt-2" @click="submit">{{ $t("sections.user.dataForm.action.btnSave") }}</vs-button>
                <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset">{{ $t("sections.user.dataForm.action.btnReset") }}</vs-button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { ValidationProvider } from 'vee-validate'
import { createNamespacedHelpers, mapGetters } from 'vuex'

const {mapActions: mapSystemActions, mapState: mapSystemFields} = createNamespacedHelpers('System')

export default {
  components: {
    vSelect,
    ValidationProvider
  },

  data () {
    return {
      form:{
        nameTh: '',
        nameEn: '',
        status: 'Enabled',
        permissions: []
      }
    }
  },
  async created () {
    await this.getSubMenus()
    this.pms ('SystemRole', 'create', 'r')
    this.form.permissions = this.permissionsSubMenu.map(res=>{return {...res,visible: false,create: false,edit: false,delete: false} })
  },
  computed: {
    ...mapSystemFields(['status']),
    ...mapGetters({
      statusesOptions :'Master/statusesOptions',
      permissionsSubMenu :'System/permissionsSubMenu',
    })
  },
  methods: {
    ...mapSystemActions(['getSubMenus', 'createRole']),
    async submit () {
      const vm = this
      vm.$refs['form'].validate().then(success => {
        if (!success) {
          return
        }

        vm.createRole({
          form: {
            nameTh: vm.form.nameTh,
            nameEn: vm.form.nameEn,
            status: vm.form.status.value || vm.form.status,
            permissions: vm.form.permissions.map(res=>{
              return {
                subMenuID: res.id,
                visible: res.visible,
                create: res.create,
                edit: res.edit,
                delete: res.delete
              }
            })
          },
          vm,
          redirect: "/system/role"
        })
      })
    },
    reset () {
      this.form = {
        prefix: '',
        name: '',
        surname: 'Enabled',
      }
    }
  },
  watch: {
      status: {
        handler(res) {
          if (res.processing !== null) {
            if (res.processing) {
              this.$vs.loading();
            } else {
              this.$vs.loading.close();
            }
          }
          if (res.success !== null) {
            this.$vs.notify({...res.success})
          } else if (res.error !== null) {
            this.$vs.notify({...res.error})
          }
        },
        deep: true
      },
  }
}
</script>
